export default __webpack_public_path__ + "static/media/doc.f1815484.svg";